import React, { Component } from 'react';
import {
    Container, Segment, Header, Button, Grid, Loader
} from 'semantic-ui-react';
import Moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
    getUserBenefitConfig,
    getUserConfigBenefit,
    checkEcardAllow
} from '../../actions';
import EcardPersonFilter from '../../component/ecard/ecard_person_filter';
import EcardCompanyFilter from '../../component/ecard/ecard_company_filter';
import EcardDisplay from '../../component/ecard/ecard_display';

class EcardPage extends Component {
    state = {
        companyName: this.props.user.companies[0].companyName || null,
        selectedCompany: this.props.user.companies[0].companyId || null,
        selectedPerson: this.props.user.uuid || null,
        showFront: true,
        currentDateTime: new Date()
    }
    
    componentDidMount() {
        this.timer = setInterval(() => this.setState({ currentDateTime: new Date() }), 1000);
        const { accessToken, uuid } = this.props.user;
        this.props.checkEcardAllow({accessToken, userId: uuid, companyId: this.state.selectedCompany})
        this.props.getUserBenefitConfig({accessToken, userId: uuid, companyId: this.state.selectedCompany});
        this.props.getUserConfigBenefit({accessToken, companyId: this.state.selectedCompany});
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }
    updatePersonSelected = (uuid) => {
        this.setState({selectedPerson: uuid, showFront: true});
        // if (!this.props.benefits[uuid]) {
            this.props.getUserBenefitConfig({accessToken: this.props.user.accessToken, userId: uuid, companyId: this.state.selectedCompany});
        // }
        // if (!this.props.configBenefit) {
            this.props.getUserConfigBenefit({accessToken: this.props.user.accessToken, companyId: this.state.selectedCompany});
        // }
    }
    updateCompanySelected = (companyId) => {
        const selectedCompany = this.props.user.companies.filter( company => company.companyId === companyId );
        const uuid = selectedCompany[0].records[0].uuid;
        const selectedCompanyName = selectedCompany[0].companyName;


        this.setState({
            companyName : selectedCompanyName,
            selectedCompany: companyId, 
            selectedPerson: uuid
        });
        // if (!this.props.benefits[uuid]) {
            this.props.getUserBenefitConfig({accessToken: this.props.user.accessToken, userId: uuid, companyId});
        // }
        // if (!this.props.configBenefit) {
            this.props.getUserConfigBenefit({accessToken: this.props.user.accessToken, companyId});
        // }
    }
    render() {
        var panelBenefits = null
        var specialRemarks = null
        if (this.props.benefits[this.state.selectedPerson] !== undefined) {
            var {
                panelBenefits,
                specialRemarks,
            } = this.props.benefits[this.state.selectedPerson];
        }

        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    Ecards
                </Header>
                <Segment attached>
                    <Grid columns={3}>
                        {this.props.user && this.props.user.companies && this.props.user.companies.length > 1 &&
                        <Grid.Column>
                            <EcardCompanyFilter
                                user={this.props.user}
                                selectedCompany={this.state.selectedCompany}
                                updateCompanySelected={this.updateCompanySelected}
                            />
                        </Grid.Column>}
                        <Grid.Column>
                            <EcardPersonFilter
                                user={this.props.user}
                                selectedCompany={this.state.selectedCompany}
                                selectedPerson={this.state.selectedPerson}
                                updatePersonSelected={this.updatePersonSelected}
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <Button
                                fluid
                                onClick={() => this.setState({showFront: !this.state.showFront})}
                            >
                                Flip Ecard
                            </Button>
                        </Grid.Column>

                    </Grid>
                </Segment>
                <Segment attached>
                    <Grid.Column textAlign="center" verticalAlign="middle">
                        <h4>
                            {Moment(this.state.currentDateTime).format('DD MMMM YYYY HH:mm:ss A')}
                        </h4>
                    </Grid.Column>
                    <EcardDisplay
                        showFront={this.state.showFront}
                        benefits={this.props.benefits[this.state.selectedPerson] || null}
                        configBenefit={this.props.configBenefit || null}
                    />
                </Segment>
                <Segment attached>
                    <h4>
                        Please present the e-Card with your Identity Card (IC) when you register at Income's GroupCare panel of clinics.
                    </h4>
                    <h4>
                        Benefits
                    </h4>
                    <ul>
                        {
                            _.map(panelBenefits, (panelBenefit, index) => {
                                return(
                                    <li key={index}>
                                        {panelBenefit.p} - {panelBenefit.e}
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <h4>
                        Remarks
                    </h4>
                    <p>
                        {specialRemarks || "N.A."}
                    </p>
                </Segment>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        benefits: state.user.benefits,
        configBenefit: state.user.configBenefit,
        ecard: state.ecard,
    };
}

export default connect(mapStateToProps, {
    getUserBenefitConfig,
    getUserConfigBenefit,
    checkEcardAllow
})(EcardPage);
